(() => {
  const config = JSON.parse(document.getElementById("oi-config").textContent);
  const root = config.root.endsWith("/") ? config.root : `${config.root}/`;
  const cartDialog = document.getElementById("oi-cart");
  const wishlistDialog = document.getElementById("oi-wishlist");
  const status = document.querySelector("[data-site-status]");
  let favorites = readFavorites();
  let cartQueue = Promise.resolve();
  let wishlistRequest;
  const money = new Intl.NumberFormat(config.locale, {
    style: "currency",
    currency: config.currency,
  });

  function readFavorites() {
    try {
      const stored = JSON.parse(
        localStorage.getItem("oliara_wishlist") || "[]",
      );
      return new Set(
        Array.isArray(stored)
          ? stored
              .filter(
                (handle) =>
                  typeof handle === "string" && /^[a-z0-9-]+$/.test(handle),
              )
              .slice(0, 100)
          : [],
      );
    } catch {
      return new Set();
    }
  }

  function syncFavorites() {
    document.querySelectorAll("[data-favorite]").forEach((button) => {
      button.hidden = false;
      button.setAttribute(
        "aria-pressed",
        String(favorites.has(button.dataset.favorite)),
      );
    });
  }

  function saveFavorites() {
    try {
      localStorage.setItem("oliara_wishlist", JSON.stringify([...favorites]));
    } catch {}
    syncFavorites();
  }

  function openDialog(dialog) {
    document.querySelectorAll("dialog[open]").forEach((open) => {
      if (open !== dialog) open.close();
    });
    if (!dialog.open) dialog.showModal();
  }

  async function refreshCart(html) {
    if (!html) {
      const url = new URL(root, location.origin);
      url.searchParams.set("sections", "oliara-cart-drawer");
      const response = await fetch(url);
      if (!response.ok) throw new Error(config.error);
      html = (await response.json())["oliara-cart-drawer"];
    }
    if (!html) throw new Error(config.error);
    const parsed = new DOMParser().parseFromString(html, "text/html");
    const content = parsed.querySelector("[data-cart-content]");
    if (!content) throw new Error(config.error);
    cartDialog.querySelector("[data-cart-content]").replaceWith(content);
    document.querySelectorAll("[data-cart-count]").forEach((node) => {
      node.textContent = content.dataset.itemCount;
    });
  }

  async function renderWishlist() {
    wishlistRequest?.abort();
    const controller = new AbortController();
    wishlistRequest = controller;
    const list = wishlistDialog.querySelector("[data-wishlist-list]");
    list.textContent = favorites.size ? config.loading : config.empty;
    if (!favorites.size) return;
    const handles = [...favorites];
    const products = await Promise.all(
      handles.map(async (handle) => {
        try {
          const response = await fetch(
            `${root}products/${encodeURIComponent(handle)}.js`,
            { signal: controller.signal },
          );
          if (!response.ok) return { handle, unavailable: true };
          return { ...(await response.json()), handle };
        } catch (error) {
          if (error.name === "AbortError") throw error;
          return { handle, unavailable: true };
        }
      }),
    );
    if (controller.signal.aborted) return;
    list.replaceChildren();
    products.forEach((product) => {
      const article = document.createElement("article");
      article.className = "oi-wishlist-item";
      if (product.featured_image) {
        const image = document.createElement("img");
        const url = new URL(product.featured_image, location.origin);
        url.searchParams.set("width", "160");
        image.src = url.href;
        image.alt = "";
        image.width = 72;
        image.height = 90;
        image.loading = "lazy";
        article.append(image);
      }
      const info = document.createElement("div");
      const title = document.createElement("h3");
      if (product.unavailable) title.textContent = config.unavailable;
      else {
        const link = document.createElement("a");
        link.href = `${root}products/${encodeURIComponent(product.handle)}`;
        link.textContent = product.title;
        title.append(link);
      }
      info.append(title);
      if (!product.unavailable) {
        const price = document.createElement("p");
        price.textContent = money.format(product.price / 100);
        info.append(price);
      }
      const remove = document.createElement("button");
      remove.type = "button";
      remove.className = "oi-link";
      remove.dataset.removeFavorite = product.handle;
      remove.textContent = config.remove;
      info.append(remove);
      article.append(info);
      list.append(article);
    });
  }

  function loadWishlist() {
    renderWishlist().catch((error) => {
      if (error.name !== "AbortError")
        wishlistDialog.querySelector("[data-wishlist-list]").textContent =
          config.error;
    });
  }

  document.addEventListener("click", (event) => {
    const cartLink = event.target.closest("[data-open-cart]");
    if (
      cartLink &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey &&
      !event.altKey
    ) {
      event.preventDefault();
      openDialog(cartDialog);
      cartQueue = cartQueue
        .catch(() => {})
        .then(() => refreshCart())
        .catch(() => {
          location.href = `${root}cart`;
        });
    }
    if (event.target.closest("[data-open-wishlist]")) {
      openDialog(wishlistDialog);
      loadWishlist();
    }
    if (event.target.closest("[data-close-dialog]"))
      event.target.closest("dialog").close();
    const favorite = event.target.closest("[data-favorite]");
    if (favorite) {
      const handle = favorite.dataset.favorite;
      if (favorites.has(handle)) favorites.delete(handle);
      else if (favorites.size < 100) favorites.add(handle);
      saveFavorites();
    }
    const remove = event.target.closest("[data-remove-favorite]");
    if (remove) {
      favorites.delete(remove.dataset.removeFavorite);
      saveFavorites();
      loadWishlist();
    }
    const navLink = event.target.closest(".oi-mobile-menu a");
    if (navLink) navLink.closest("details.oi-mobile-menu").open = false;
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape")
      document
        .querySelectorAll(".oi-mobile-menu[open], .oi-submenu[open]")
        .forEach((menu) => {
          menu.open = false;
          menu.querySelector("summary").focus();
        });
  });
  document.querySelectorAll(".oi-drawer").forEach((dialog) => {
    dialog.addEventListener("click", (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom
      )
        dialog.close();
    });
  });

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!form.matches(".oi-product-form")) return;
    event.preventDefault();
    const button = form.querySelector("[name=add]");
    const errorNode = form.querySelector("[data-form-error]");
    if (button.disabled) return;
    const data = new FormData(form);
    data.set("sections", "oliara-cart-drawer");
    data.set("sections_url", location.pathname);
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    errorNode.textContent = "";
    cartQueue = cartQueue
      .catch(() => {})
      .then(async () => {
        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: "POST",
            body: data,
            headers: { Accept: "application/json" },
          });
          const result = await response.json();
          if (!response.ok)
            throw new Error(
              result.description || result.message || config.error,
            );
          status.textContent = config.added;
          try {
            await refreshCart(result.sections?.["oliara-cart-drawer"]);
            openDialog(cartDialog);
          } catch {
            location.href = `${root}cart`;
          }
        } catch (error) {
          errorNode.textContent = error.message || config.error;
        } finally {
          button.disabled = false;
          button.removeAttribute("aria-busy");
        }
      });
  });

  window.addEventListener("storage", (event) => {
    if (event.key === "oliara_wishlist") {
      favorites = readFavorites();
      syncFavorites();
      if (wishlistDialog.open) loadWishlist();
    }
  });
  document.addEventListener("shopify:section:load", () => {
    syncFavorites();
    document.querySelectorAll("[data-open-wishlist]").forEach((button) => {
      button.hidden = false;
    });
  });
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      favorites = readFavorites();
      syncFavorites();
      refreshCart().catch(() => {});
    }
  });
  media.addEventListener("change", syncTheme);
  document.querySelectorAll("[data-open-wishlist]").forEach((button) => {
    button.hidden = false;
  });
  syncFavorites();
  syncTheme();
})();
